/* codul-cta-clone.js — replicate the hero buy-box [stock text + ADAUGĂ ÎN COȘ
   button] above EVERY repeated Releasit COD button.
   The repeated CTAs are Releasit app-block sections (.rsi-app-block-container)
   into which we cannot inject Liquid, so at runtime we clone the hero's own
   stock line + product form and insert a copy as the first child of each
   Releasit container — exactly like the hero. The cloned <form class="codul-form">
   adds to cart automatically because codul-cart.js handles submits via a
   delegated listener on document (no per-form wiring needed).
   Idempotent; also watches for Releasit containers that render slightly late. */
(function () {
  if (window.__codulCtaCloneInit) return;
  window.__codulCtaCloneInit = true;

  // The Releasit section directly after the hero already has the hero's own
  // native [stock + ADAUGĂ] block right above it → injecting there would make a
  // visible duplicate at the top. Identify that container's section so we skip it.
  function heroAdjacentSection() {
    var hero = document.querySelector('.codul-hero');
    var heroSection = hero ? hero.closest('.shopify-section') : null;
    if (!heroSection) return null;
    var n = heroSection.nextElementSibling;
    while (n && !(n.classList && n.classList.contains('shopify-section'))) n = n.nextElementSibling;
    return n; // the first section after the hero (the hero-adjacent Releasit slot)
  }

  function build() {
    var heroBuy = document.querySelector('.codul-hero__buy');
    if (!heroBuy) return true; // no hero on this page → nothing to do, stop trying
    var stock = heroBuy.querySelector('.codul-stock');
    var form = heroBuy.querySelector('.codul-form');
    if (!stock && !form) return true; // nothing to clone (button may be hidden via show_cart_button)

    var containers = document.querySelectorAll('.rsi-app-block-container');
    if (!containers.length) return false; // Releasit not rendered yet → retry later
    var skipSection = heroAdjacentSection();
    containers.forEach(function (c) {
      if (skipSection && skipSection.contains(c)) return; // hero already covers this one
      if (c.querySelector('.codul-cta-inject')) return; // already injected here
      var wrap = document.createElement('div');
      wrap.className = 'codul codul-cta-inject';
      if (stock) wrap.appendChild(stock.cloneNode(true));
      if (form) wrap.appendChild(form.cloneNode(true)); // button only if show_cart_button is on
      c.insertBefore(wrap, c.firstChild);
    });
    return true;
  }

  function run() {
    try { return build(); } catch (e) { return false; }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Safety net: Releasit may render its containers a moment after load.
  var tries = 0;
  var iv = setInterval(function () {
    if (run() || ++tries >= 12) clearInterval(iv);
  }, 500);
})();
